// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__27Nxi","title":"styles_title__1yOsu"};